import React from "react";
import { IconBan, IconTrashFilled } from "@tabler/icons-react";
import { useAuth } from "../../../Auth/AuthProvider";
import deleteRequest from "../../../_Firestore/deleteRequest";

export default function Deleted({ requests }) {
  const { uid } = useAuth();

  const deleteAll = (e) => {
    e.preventDefault();
    if (
      window.confirm(
        "Are you sure you want to delete all Requests? This action cannot be undone!",
      )
    ) {
      requests.length &&
        requests.map((request) => {
          deleteRequest.hard(request.props.request_id, uid);
          return true;
        });
    }
  };

  return (
    <div>
      <div className="mb-3 flex items-center justify-between font-semibold text-mauve-600">
        <div className="flex items-center gap-2">
          <IconTrashFilled className="size-4" />
          {requests.length ? (
            <span>Deleted Requests</span>
          ) : (
            <span>Nothing here</span>
          )}
        </div>

        {requests.length ? (
          <button
            type="button"
            onClick={deleteAll}
            className="inline-flex items-center text-sm text-red-600 hover:text-red-700"
          >
            <IconBan className="mr-2 size-4" />
            Empty trash
          </button>
        ) : null}
      </div>

      {requests}
    </div>
  );
}
